import { BaseSkeleton } from 'components/BaseSkeleton'

export function NicheTableCellSkeleton(props) {
  if (props?.row?.isLoading) {
    return <BaseSkeleton height={12} borderRadius={20} width={80} containerClassName="SkeletonTable-lines" />
  }
  return props.children
}
